import React, { useState} from 'react';
import ImportForm from '../components/imports/ImportForm';
import ImportHistory from '../components/imports/ImportHistory';

const ImportsPage = () => {
  const [importComplete, setImportComplete] = useState(null);
  // Utiliser un compteur pour forcer le rechargement de l'historique
  const [refreshKey, setRefreshKey] = useState(0);
  
  const handleImportComplete = (data) => {
    console.log('Données reçues:', data); // Pour débugger
    setImportComplete(data);
    
    // Forcer le rechargement de l'historique en incrémentant la clé
    setRefreshKey(oldKey => oldKey + 1);
    
    // Réinitialiser le message après 10 secondes
    setTimeout(() => {
      setImportComplete(null);
    }, 10000);
  };
  
  // Fonction pour extraire les valeurs correctement
  const getImportStats = () => {
    if (!importComplete) return { new: 0, updated: 0 };
    
    // D'après notre code, la structure est
    // importComplete.summary.imported et importComplete.summary.updated
    // Ou potentiellement importComplete.newRecords et importComplete.updatedRecords
    
    const newImports = importComplete.summary?.imported || 
                       importComplete.newRecords || 
                       importComplete.import?.new || 
                       0;
                       
    const updatedImports = importComplete.summary?.updated || 
                          importComplete.updatedRecords || 
                          importComplete.import?.updated || 
                          0;
    
    return { new: newImports, updated: updatedImports };
  };
  
  const stats = getImportStats();
  
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Importation de données</h1>
      
      {importComplete && (
        <div className="bg-green-100 p-4 rounded-md text-green-700 mb-4">
          Importation terminée! {stats.new} nouveaux enregistrements et {stats.updated} mises à jour.
        </div>
      )}
      
      <div className="grid grid-cols-1 gap-6">
        <ImportForm onImportComplete={handleImportComplete} />
        <ImportHistory key={refreshKey} />
      </div>
    </div>
  );
};

export default ImportsPage;